"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBeforeModifier = void 0;
var isBeforeModifier = function (blackout) {
    return "before" in blackout;
};
exports.isBeforeModifier = isBeforeModifier;
